import request from '@/utils/request'

// App获取跑马灯列表
export function listMarqueeBulletins() {
  return request({
    url: '/bulletin/app/listMarqueeBulletins',
    method: 'get',
  })
}

// 获取上传公告媒体的密文
export function getUploadBulletinMediaCiphertext(params) {
  return request({
    url: '/bulletin/getUploadBulletinMediaCiphertext',
    method: 'get',
    params,
  })
}

// 更新公告
export function updateBulletin(id, data) {
  return request({
    url: `/bulletin/updateBulletin/${id}`,
    method: 'patch',
    data,
  })
}

// 公告列表
export function listBulletins(params) {
  return request({
    url: '/bulletin/listBulletins',
    method: 'get',
    params,
  })
}

// 删除公告
export function deleteBulletin(id) {
  return request({
    url: `/bulletin/deleteBulletin/${id}`,
    method: 'delete',
  })
}

// 新增公告
export function addBulletin(data) {
  return request({
    url: '/bulletin/addBulletin',
    method: 'post',
    data,
  })
}


// WEBPACK FOOTER //
// ./src/api/bulletin.js